import script from "./PostDisbursementChangeForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./PostDisbursementChangeForm.vue?vue&type=script&setup=true&lang=ts"

import "@/assets/css/loans/form.css?vue&type=style&index=0&id=3493a700&scoped=true&lang=css&external"
import "./PostDisbursementChangeForm.vue?vue&type=style&index=1&id=3493a700&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3493a700"]])

export default __exports__